import type { InputMaybe, Scalars } from '../scalars';
import type {
  CodingConfigUnionInput,
  PrintSettingsInput,
  SectionInput,
} from '../gql/graphql';

/** Quotation Input */
export class QuotationInput {
  /** Quotation's id */
  readonly _id?: InputMaybe<Scalars['Id']['input']>;
  /** Quotation's coding config */
  readonly codingConfig: CodingConfigUnionInput;
  /** Quotation's print settings */
  readonly printSettings: PrintSettingsInput;
  /** Quotation's template id */
  readonly templateId: Scalars['Id']['input'];
  /** Quotation's title */
  readonly title: Scalars['NonEmptyString']['input'];
  /** Quotation's virtual root */
  readonly virtualRoot: SectionInput;
}
